import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query'
import { IOncologyDiagnosis, OncologyDiagnosesFetchParams } from '~/interfaces'
import { fetchOncologyDiagnoses, message } from '~/services'
import { hasObjectValue } from '~/utils'

const UNIQUE_KEY = 'oncologyDiagnoses'

export const useFetchOncologyDiagnoses = (
  params: OncologyDiagnosesFetchParams,
  config?: UseQueryOptions<IOncologyDiagnosis, Error>
): UseQueryResult<IOncologyDiagnosis, Error> => {
  const fetcher = async (): Promise<IOncologyDiagnosis> => {
    try {
      return await fetchOncologyDiagnoses(params)
    } catch (error) {
      if (typeof error === 'string') throw new Error(error)
      throw new Error(message('messages.genericUnexpectedError'))
    }
  }

  const hasParams = hasObjectValue({ params })

  return useQuery<IOncologyDiagnosis, Error>([UNIQUE_KEY, params], fetcher, {
    cacheTime: Infinity,
    staleTime: Infinity,
    enabled: hasParams,
    ...config
  })
}
